import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { useMaintenance } from '../../contexts/MaintenanceContext';
import { useLanguage } from '../../contexts/LanguageContext';
import MaintenanceOffline from './MaintenanceOffline';
import MaintenanceManager from '../../pages/Maintenance/MaintenanceManager';
import './Maintenance.css';

export default function MaintenanceGate({ children }) {
  const { state, checking, blocked, accountOwner, canManageMaintenance, accessLoading, online, error } = useMaintenance();
  const { language } = useLanguage(), location = useLocation(), navigate = useNavigate();
  const authRoute = ['/login', '/emergency-login', '/reset-password', '/verify-email'].includes(location.pathname);
  const unavailable = online === false || (error && !authRoute);
  const offlineRoute = location.pathname === '/offline' || location.pathname.startsWith('/offline/');
  useEffect(() => {
    // A disconnected launch always starts at the activity hub. Explicit offline
    // routes remain open through reconnects, so reading/counting is uninterrupted.
    if (unavailable && !offlineRoute) navigate('/offline', { replace: true });
  }, [unavailable, offlineRoute, navigate]);
  if (offlineRoute || unavailable) return <MaintenanceOffline/>;
  if (!authRoute && (checking || accessLoading)) return <div className="maintenance-loading" role="status">{language === 'ar' ? 'جارٍ الاتصال بأمبوستر…' : 'Connecting to Amposter…'}</div>;
  if (blocked && !authRoute) {
    // Keep the rest of the online app unmounted for delegated managers.
    if (canManageMaintenance && location.pathname === '/admin/maintenance') return <MaintenanceManager/>;
    return <MaintenanceOffline/>;
  }
  return <>{state.enabled && accountOwner && location.pathname !== '/admin/maintenance' && <button className="maintenance-owner-shortcut" onClick={() => navigate('/admin/maintenance')}><Wrench size={17}/>{language === 'ar' ? 'الصيانة مفعّلة · إدارة الصيانة' : 'Maintenance is on · Manage'}</button>}{children}</>;
}
